/* ============================================================
   Lumynest — colour label prettifier (DISPLAY ONLY)

   Supplier option values are the join key the dropship app uses
   to map a Shopify variant to a supplier SKU. Renaming them in
   Shopify breaks fulfilment. So we never touch the stored value.

   This rewrites only the visible TEXT of an option button or
   dropdown. data-lmp-ov, <option value>, the variant title and
   everything Shopify or the supplier reads stay exactly as-is.

   Rules are limited to changes whose meaning is certain:
   stripping supplier SKU fragments and translating Chinese
   manufacturing terms. Ambiguous colour names are left alone
   rather than guessed at.
   ============================================================ */
(function (w) {
  'use strict';

  var OVERRIDES = {
    /* Stiletto heels. houkong = open back (slingback). all inclusive = closed back. */
    'Off-white all inclusive-8cm':  'Off-White \u00b7 Closed back \u00b7 8cm heel',
    'Black all inclusive-8cm':      'Black \u00b7 Closed back \u00b7 8cm heel',
    'Silver all inclusive-8cm':     'Silver \u00b7 Closed back \u00b7 8cm heel',
    'Off-white. all inclusive-6cm': 'Off-White \u00b7 Closed back \u00b7 6cm heel',
    'Black. all inclusive-6cm':     'Black \u00b7 Closed back \u00b7 6cm heel',
    'Silver. all inclusive-6cm':    'Silver \u00b7 Closed back \u00b7 6cm heel',
    'Off-whiteback space-6cm':      'Off-White \u00b7 Slingback \u00b7 6cm heel',
    'Blackhoukong-6cm':             'Black \u00b7 Slingback \u00b7 6cm heel',
    'Silverhoukong-6cm':            'Silver \u00b7 Slingback \u00b7 6cm heel',

    /* Sneakers */
    'Womens white':                 'White \u00b7 Women\u2019s fit',
    'Mens black white background':  'Black & White \u00b7 Men\u2019s fit',

    /* Knee boots. Single lining = one layer of lining, not unlined. */
    'Black Single Lining':          'Black \u00b7 Standard lining',
    'Brown Single Lining':          'Brown \u00b7 Standard lining',
    'Black Fleece Lined':           'Black \u00b7 Fleece lined',
    'Brown Fleece Lined':           'Brown \u00b7 Fleece lined',

    /* Slouch boots. Upgraded is the supplier grade, kept as-is. */
    'Upgraded Khaki':               'Khaki \u00b7 Upgraded',
    'Upgraded Brown':               'Brown \u00b7 Upgraded',

    /* Wide leg trousers. Inseam baked into the colour value. */
    'Black Lengthen 32':            'Black \u00b7 32in inseam',
    'Black Regular 30':             'Black \u00b7 30in inseam',
    'Dark gray lengthened 32':      'Charcoal \u00b7 32in inseam',
    'Dark gray regular 30':         'Charcoal \u00b7 30in inseam',
    'Khakis lengthening 32':        'Khaki \u00b7 32in inseam',
    'Khaki Regular 30':             'Khaki \u00b7 30in inseam',
    'Skin color lengthened by 32':  'Nude \u00b7 32in inseam',
    'Skin color regular 30':        'Nude \u00b7 30in inseam',
    'White Lent 32':                'White \u00b7 32in inseam',
    'White conventional 30':        'White \u00b7 30in inseam',
    'Brown Led 32':                 'Brown \u00b7 32in inseam',
    'Brown Regular 30':             'Brown \u00b7 30in inseam',

    /* Jeans */
    'Cement gray trousers':         'Cement Grey \u00b7 Regular',
    'Cement gray extension':        'Cement Grey \u00b7 Long',

    /* Pleated skirt. Two lengths sold under one product. */
    'Navy Blue Long Dress 75cm':    'Navy \u00b7 75cm',
    'Black Midi Skirt 60cm':        'Black \u00b7 60cm',
    'Black Long Dress 75cm':        'Black \u00b7 75cm',
    'Navy Blue Midi Skirt 60cm':    'Navy \u00b7 60cm',

    /* Common supplier colour terms */
    'Skin color':                   'Nude',
    'Flower ash':                   'Heather Grey',
    'Moon White':                   'Off-White',
    'Samurai Black':                'Black',
    'White Gold Necklace DZ-352':   'White Gold'
  };

  /* Supplier SKU fragments that mean nothing to a shopper. */
  var STRIP = [
    /^GK0?2\s*overalls\s*/i,
    /^M1?02\s*-\s*/i,
    /\s*-?\s*(DZ|SL)-\d+\s*$/i
  ];

  function titleCase(s) {
    return s.replace(/[A-Za-z\u00C0-\u024F\u2019']+/g, function (word) {
      if (word.length <= 2 && word === word.toUpperCase()) return word;
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
  }

  function pretty(raw) {
    if (!raw) return raw;
    var key = String(raw).trim();
    if (Object.prototype.hasOwnProperty.call(OVERRIDES, key)) return OVERRIDES[key];

    var out = key;
    for (var i = 0; i < STRIP.length; i++) out = out.replace(STRIP[i], '');
    out = out.replace(/\s{2,}/g, ' ').trim();
    if (!out) return key;

    if (out === out.toLowerCase() || out === out.toUpperCase()) out = titleCase(out);
    return out;
  }

  function isColourOption(name) {
    return /colou?r/i.test(String(name || ''));
  }

  function optionNames() {
    var el = document.querySelector('[data-lmp-options]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  function apply(scope) {
    var root = scope || document;
    var names = optionNames();

    root.querySelectorAll('[data-lmp-oi][data-lmp-ov]').forEach(function (btn) {
      if (btn.getAttribute('data-lum-relabelled')) return;
      var idx = parseInt(btn.getAttribute('data-lmp-oi'), 10);
      if (!isColourOption(names[idx])) return;
      var raw = btn.getAttribute('data-lmp-ov');
      var nice = pretty(raw);
      if (nice && nice !== raw) {
        btn.textContent = nice;
        btn.setAttribute('title', raw);
      }
      btn.setAttribute('data-lum-relabelled', '1');
    });

    root.querySelectorAll('select[data-pick-opt], select[data-comp-opt]').forEach(function (sel) {
      var attr = sel.hasAttribute('data-pick-opt') ? 'data-pick-opt' : 'data-comp-opt';
      var idx = parseInt(sel.getAttribute(attr), 10);
      var label = sel.getAttribute('aria-label') || names[idx];
      if (!isColourOption(label)) return;
      Array.prototype.forEach.call(sel.options, function (opt) {
        if (!opt.value || opt.getAttribute('data-lum-relabelled')) return;
        var nice = pretty(opt.value);
        if (nice && nice !== opt.value) {
          opt.textContent = nice;
          opt.title = opt.value;
        }
        opt.setAttribute('data-lum-relabelled', '1');
      });
    });
  }

  w.LumynestLabels = { pretty: pretty, apply: apply };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(); });
  } else {
    apply();
  }

  /* Bundle rows are built after a tier is chosen, so re-run then. */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-lmp-tier], [data-lmp-mode], .lmp-comp')) {
      setTimeout(apply, 0);
    }
  });
})(window);
